import {ColorSet} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/color.types';
import {useSelectedDiscount} from './useSelectedDiscount';

/**
 * Returns the selected campaign's colour pair (foreground/background) served by
 * the backend, or `undefined` when no campaign is selected.
 *
 * The pair is gender-agnostic: the backend resolves the target group from the
 * `GetDiscountsRequest` (web already sends it via `useDiscounts`), so the
 * frontend no longer picks a banner colour client-side. This also removes the
 * previous male/female swap. Each call site applies `foregroundColor.hex`
 * (text / glyphs) or `backgroundColor.hex` (surface). See ASFE-14225.
 */
export function useSelectedDiscountColor(): ColorSet | undefined;

export function useSelectedDiscountColor() {
  const selectedDiscount = useSelectedDiscount();

  if (!selectedDiscount) {
    return;
  }

  return selectedDiscount.colors;
}

/**
 * Returns the selected campaign's countdown colour pair, resolved independently
 * from the primary `colors` so the timer can follow per-campaign-type rules.
 * See `GetDiscountsResponse_Discount.countdownColors` and ASFE-14225.
 */
export function useSelectedDiscountCountdownColor(): ColorSet | undefined {
  const selectedDiscount = useSelectedDiscount();

  if (!selectedDiscount) {
    return;
  }

  return selectedDiscount.countdownColors;
}
